import { Component, type SyntheticEvent } from "react";
import { Section } from "../atoms/section";
import {
    type IPanelProps,
    Stack,
    type IRenderFunction,
    Panel,
    PanelType,
    SelectionMode,
} from "@fluentui/react";
import { ListVehicles, ListVehiclesLayout } from "./list-vehicles";
import { ListUserGroups } from "./list-user-groups";
import { type UUID } from "../../utils/uuid";
import { observer } from "mobx-react";
import { action } from "mobx";
import css from "./panel-vehicle-group-details.scss";
import { ListCommandButtonsVehicleGroups } from "../organisms/list-command-buttons-vehicle-groups";
import { mapSome } from "../../utils/functions";

export interface PanelVehicleGroupDetailsProps {
    readonly isOpen: boolean;
    readonly vehicleGroupId?: UUID;
    readonly onDismiss: (ev?: SyntheticEvent<HTMLElement> | KeyboardEvent) => void;
}

import { store } from "../../store";

@observer
export class PanelVehicleGroupDetails extends Component<PanelVehicleGroupDetailsProps> {
    @action.bound private renderHeader(): IRenderFunction<IPanelProps> {
        return (props, defaultRender) => (
            <>
                {defaultRender!(props)}
                <Stack horizontal verticalAlign="center">
                    <div className={css.commandButtons}>
                        <ListCommandButtonsVehicleGroups
                            canDelete
                            singleItemMode
                            itemId={this.props.vehicleGroupId}
                            onDelete={(_evt) => this.props.onDismiss()}
                        />
                    </div>
                </Stack>
            </>
        );
    }

    public render(): JSX.Element {
        if (!this.props.vehicleGroupId) {
            return <></>;
        }

        const vehicleGroup = store.repositoryVehicleGroups.byId(this.props.vehicleGroupId);
        const vehicleCount =
            mapSome((count) => `(${count})`, vehicleGroup?.assignedVehicleCount) ?? "";
        const userGroupCount =
            mapSome((count) => `(${count})`, vehicleGroup?.assignedUserGroupCount) ?? "";

        return (
            <Panel
                isOpen={this.props.isOpen}
                isBlocking={false}
                onDismiss={this.props.onDismiss}
                onRenderHeader={this.renderHeader()}
                type={PanelType.large}
                headerText={vehicleGroup?.label}
            >
                <div className="flex flex-wrap gap-4">
                    <Section
                        withPadding
                        title={`${store.i18n.t(
                            "component.panelVehicleGroupDetails.vehicles.title",
                        )} ${vehicleCount}`}
                        className="min-w-xl flex-1"
                    >
                        <ListVehicles
                            selectionMode={SelectionMode.none}
                            columnLayout={ListVehiclesLayout.Group}
                            vehicleGroupIds={[this.props.vehicleGroupId]}
                            ignoreUrl
                            hideFilter
                        />
                    </Section>
                    <Section
                        withPadding
                        title={`${store.i18n.t(
                            "component.panelVehicleGroupDetails.userGroups.title",
                        )} ${userGroupCount}`}
                        className="min-w-xl flex-1"
                    >
                        <ListUserGroups
                            selectionMode={SelectionMode.none}
                            vehicleGroupIds={[this.props.vehicleGroupId]}
                            ignoreUrl
                        />
                    </Section>
                </div>
            </Panel>
        );
    }
}
